import { useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";

const MockLoginPage = () => {
  const auth = useAuth();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    }
    handleResize();
    window.addEventListener('resize', handleResize);
  }, []);


  return (<div style={{
    padding: '1rem',
    ...(isMobile && {
      padding: '5rem 1rem'
    })
  }}>
    <button style={{
      padding: '8px 12px', border: 'none', borderRadius: '6px',
      ...(isMobile && {
        fontSize: '12px'
      })
    }} onClick={() => auth.signinRedirect({extraQueryParams: {prompt: 'login select_account', max_age: '0', }})}>Sign into AA BCP</button>
  </div>);
};

export default MockLoginPage;
